/**
 * Describe your function here
 * @param { * } data - Function input
 * @return { * } - Function response
 */

const isValid = (entry) => {
  const re = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/;
  return re.test(entry);
};

const clean = entry => (entry ? entry.replace(/[^\d]+/g, '') : '');

const enrich = entry => ((entry.substring(0, 1) > 5 && entry.length == 8) ? `9${entry}` : entry);

const work = (entry) => {
  const newEntry = clean(entry);
  // if(newEntry.length <= 9) newEntry = `11${newEntry}`
  const initialIndex = newEntry.length > 11 ? 4 : newEntry.length > 9 ? 2 : 0;
  const phone = enrich(newEntry.substring(initialIndex));
  const area = newEntry.substring(initialIndex - 2, initialIndex);

  return {
    phone: phone == '' ? null : +phone,
    original: entry,
    phoneArea: area == '' ? null : +area,
    countryCode: 55,
    type: phone.substring(0, 1) > 5 ? 'celular' : 'fixo',
    valid: isValid(phone),
  };
};

export default async entry => work(entry);
